import { retrieveLoggedInUserData } from '../../LoggedInUser/dispatchers';
import { currentUserIdSelector } from '../../Auth/selectors';

export const loadCurrentUserFromAuth = (dispatch, getState) =>
  dispatch(
    retrieveLoggedInUserData({
      userId: currentUserIdSelector(getState()),
    })
  );
